// Currencies the Console lists but the government utility has no code for: the
// pre-euro national currencies plus a few others that were withdrawn. Picking one
// can only produce a Form 146 the portal cannot accept, so they are kept out of the
// dropdown.
//
// Matched on the name exactly as it appears in UtilityMapping.json (typos and all),
// the same way api/cbs/services/currency_iso.py does. That module is the source of
// truth for the codes; cbs/tests_gov_json_smoke.py checks this list still agrees
// with it, so adding a code there without updating here fails the test.
export const UNSUPPORTED_CURRENCY_NAMES = [
    'ANDORAN PESTA',
    'AUSTRIAN SCHILLING',
    'BELGIAN FRANC',
    'CYPRUS POUND',
    'DEUTSCH MARK',
    'ECUADOR SUCRE',
    'ESTONIAN KROON',
    'FINISH MARKKA',
    'FRENCH FRANC',
    'GREEK DRACHMA',
    'GUINEA-BISSAU PESO',
    'IRISH POUNDS',
    'ITALIAN LIRA',
    'LATVIAN LAT',
    'LITHUANIAN LITAS',
    'LUXEMBOURG FRANCS',
    'MALTESE LIRA',
    'NETHERLANDS GUILDER',
    'PORTUGUESE ESCUDO',
    'SLOVAKI KORUNA',
    'SLOVENIAN TOLAR',
    'SPANISH PESETA',
    'TIMOR ESCUDO',
];

const excluded = new Set(UNSUPPORTED_CURRENCY_NAMES);

/**
 * Currency dropdown options with the unfilable currencies removed.
 *
 * `selectedKey` is always kept, even when excluded: an old record saved against
 * (say) Deutsche Marks must still open and show what it holds rather than appear
 * blank. The CA can then change it deliberately.
 */
export function currencyOptions(options, selectedKey) {
    if (!options) return options;
    const kept = {};
    Object.entries(options).forEach(([key, label]) => {
        const name = String(label === null || label === undefined ? '' : label).trim().toUpperCase();
        if (key === String(selectedKey) || !excluded.has(name)) {
            kept[key] = label;
        }
    });
    return kept;
}
